import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authSlice, { authListenerMiddleware } from './auth';
import sidebarSlice from './sidebar';

const rootReducer = combineReducers({
    auth: authSlice.reducer,
    sidebar: sidebarSlice.reducer,
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(authListenerMiddleware.middleware),
});

export type TRootState = ReturnType<typeof rootReducer>;

export default store;
